<div class="container g-0 m-0 p-0 mb-3">
  <div class="row-md-12 custom-margins">
    <div class="row g-0 m-0 p-2 search-dropdown">
      <div class="col-auto ps-2 pe-2">
        <img alt="Magnifier" src="assets/device/magnifier2.svg" />
      </div>
      <div class="col p-0">
        <input
          type="text"
          (keyup)="search()"
          [(ngModel)]="searchText"
          placeholder="{{ placeholder | translate }}"
        />
      </div>
    </div>
    <ul
      class="row m-0 p-0 dropdown"
      [ngClass]="{ 'no-border': !searchText || searchText === '' }"
    >
      <li
        class="list-item ps-4 pt-2 pb-2 pe-4"
        *ngFor="let item of filteredItems"
        (click)="selectItem(item)"
      >
        <span>{{ item.name }}</span>
      </li>
    </ul>
  </div>
  <div
    class="row-md-12 selected-meter-make-container custom-margins mt-3 d-flex flex-wrap gap-3"
  >
    <div
      *ngFor="let item of selectedItems"
      class="selected-meter-make ps-3 pt-2 pb-2 pe-3 d-flex justify-content-center"
    >
      <span class="pe-2" [title]="item.name || ''">{{ item.name }}</span>
      <img
        alt="Filter"
        (click)="removeItem(item)"
        src="assets/core/filter/filter-x.svg"
      />
    </div>
  </div>
</div>